/* Mama Wynja – separate mobile collection filter/sort controls – 2026-10-29
   Progressive enhancement: without JS, the original combined drawer remains. */
(() => {
  'use strict';
  const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M7 4 4 7l3 3M20 17H4m13-3 3 3-3 3"/></svg>';
  const init = () => {
    document.querySelectorAll('.facets-container[data-template="collection"]').forEach(container => {
      if (container.querySelector('.mw-mobile-collection-actions')) return;
      const drawer = container.querySelector('.mobile-facets__wrapper');
      const select = drawer?.querySelector('select[name="sort_by"]');
      if (!drawer || !select || !select.options.length) return;
      const labels = drawer.querySelectorAll('.mobile-facets__open-label.medium-hide.large-up-hide');
      labels.forEach(el => { el.textContent = 'Filtrera'; });
      const heading = drawer.querySelector('.mobile-facets__heading.medium-hide.large-up-hide');
      if (heading) heading.textContent = 'Filtrera produkter';
      const wrapper = document.createElement('div');
      wrapper.className = 'mw-mobile-collection-actions';
      drawer.parentNode.insertBefore(wrapper, drawer);
      wrapper.appendChild(drawer);
      const sort = document.createElement('details');
      sort.className = 'mw-mobile-sort';
      const summary = document.createElement('summary');
      summary.className = 'mw-mobile-sort__trigger';
      summary.setAttribute('aria-label', 'Sortera produkter');
      summary.innerHTML = icon + '<span>Sortera</span>';
      const options = document.createElement('div');
      options.className = 'mw-mobile-sort__options';
      options.setAttribute('aria-label', 'Sorteringsalternativ');
      Array.from(select.options).forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mw-mobile-sort__option';
        button.dataset.sortBy = option.value;
        button.textContent = option.value === 'manual' ? 'Utvalda' : option.textContent.trim();
        if (option.selected) button.setAttribute('aria-current', 'true');
        options.appendChild(button);
      });
      sort.append(summary, options);
      wrapper.appendChild(sort);
    });
  };
  document.addEventListener('click', event => {
    const chosen = event.target.closest('.mw-mobile-sort__option');
    if (chosen) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', chosen.dataset.sortBy);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
      return;
    }
    document.querySelectorAll('.mw-mobile-sort[open]').forEach(el => {
      if (!el.contains(event.target)) el.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mw-mobile-sort[open]').forEach(el => { el.open = false; });
  });
  const start = () => {
    init();
    const root = document.querySelector('main') || document.body;
    if (root && document.querySelector('.facets-container[data-template="collection"]')) {
      let pending = false;
      new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; init(); });
      }).observe(root, {subtree: true, childList: true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', init);
})();